require("bijou/base");
(function ($) {
  "use strict";

  var resetFieldSelector = ".js-annual_turnover_field:first";
  var annualTurnoverDropdownClass = ".js-annual_turnover_drop_down";
  var annualTurnoverFieldClass = ".js-annual_turnover_field";
  var projectedAnnualTurnoverClassName = "projected_annual_turnover";
  var currentAnnualTurnoverClassName = "current_annual_turnover";
  var fieldControlBlockClass = ".js-annual_turnover_field__control_block";
  var selectControlBlockClass = ".js-annual_turnover_select__control_block";
  var parentQuestionSelector = "select[name='years_trading']";

  var projectedGroupValues = ["I've not started yet", "Less than 1 year"];
  var currentGroupValues = [
    "1-2 years",
    "2-3 years",
    "3-4 years",
    "4-5 years",
    "Over 5 years",
  ];

  $.widget("chopin.annualTurnoverQuestion", $.bijou.base, {
    _create: function () {
      var self = this;

      $(annualTurnoverDropdownClass).each(function () {
        var $dropdown = $(this);

        self._on($dropdown, {
          change: function (event) {
            self.handleAnnualTurnoverDropdownChange($dropdown);
          },
        });
      });

      $(parentQuestionSelector).each(function () {
        var $parentQuestionDropdown = $(this);

        self._on($parentQuestionDropdown, {
          change: function () {
            if (
              $.inArray($parentQuestionDropdown.val(), projectedGroupValues) !==
              -1
            ) {
              self.handleAnnualTurnoverDropdownChange(
                $("#" + projectedAnnualTurnoverClassName),
              );
            }

            if (
              $.inArray($parentQuestionDropdown.val(), currentGroupValues) !==
              -1
            ) {
              self.handleAnnualTurnoverDropdownChange(
                $("#" + currentAnnualTurnoverClassName),
              );
            }
          },
        });
      });
    },

    handleAnnualTurnoverDropdownChange: function ($dropdown) {
      var dropdownId = $dropdown.attr("id"); // E.g. `projected_annual_turnover`
      var $annualTurnoverField = $(".js-" + dropdownId + "_field"); // E.g. `.js-projected_annual_turnover_field`
      var $annualTurnoverSection = $(fieldControlBlockClass + "." + dropdownId); // E.g. `.js-annual_turnover_field__control_block.projected_annual_turnover`

      var selectedValue = parseInt($dropdown.val());
      var resetAnnualTurnoverValue = parseInt(
        $(resetFieldSelector).attr("min"),
      );

      // Reset annual turnover input field's value or copy from dropdown
      if (selectedValue === resetAnnualTurnoverValue) {
        $annualTurnoverField.val("");
      } else {
        $annualTurnoverField.val(selectedValue);
      }

      // Toggle sections containing input field
      if (selectedValue >= resetAnnualTurnoverValue) {
        $annualTurnoverSection.addClass("on").removeClass("off").show();
      } else {
        $annualTurnoverSection.addClass("off").removeClass("on").hide();
      }

      // Set disabled attribute on the other's dropdown input field
      if (dropdownId === projectedAnnualTurnoverClassName) {
        $(".js-" + currentAnnualTurnoverClassName + "_field").attr(
          "disabled",
          "disabled",
        );
      }
      if (dropdownId === currentAnnualTurnoverClassName) {
        $(".js-" + projectedAnnualTurnoverClassName + "_field").attr(
          "disabled",
          "disabled",
        );
      }

      // Remove disabled attribute from my input field
      $(".js-" + dropdownId + "_field").removeAttr("disabled");
    },
  });
})(window.jQuery);
